import { render } from "./SolutionsList.vue?vue&type=template&id=172860cb"
import script from "./SolutionsList.vue?vue&type=script&lang=js"
export * from "./SolutionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__